const quicheLorraine = [

    { name: "З куркою та печерицями", 
        category: 'Кіш лорен',
        subCategory: '(гаряча закуска)', 
        unit: ' г', 
        amount: 550, 
        price: 400, 
        image: "/images/Kish_Loren_z_kurkoyu_ta_pecherytsyamy.jpg" 
    },

    { name: "З морепродуктами", 
        category: 'Кіш лорен',
        subCategory: '(гаряча закуска)', 
        unit: ' г', 
        amount: 550, 
        price: 450, 
        image: "/images/Kish_Loren_z_moreproduktamy.jpg" 
    },


    { name: "З сьомгою , грушею та сиром брі", 
        category: 'Кіш лорен',
        subCategory: '(гаряча закуска)', 
        unit: ' г', 
        amount: 450, 
        price: 440, 
        image: "/images/Kish_Loren_z_somgoyu_hrusheyu_ta_syrom_bri.jpg" 
    },

    { name: "3 білими грибами та печерицями", 
        category: 'Кіш лорен',
        subCategory: '(гаряча закуска)', 
        unit: ' г', 
        amount: 600, 
        price: 400, 
        image: "" 
    },

    { name: "3 бананом, чорницею та бізе", 
        category: 'Кіш лорен',
        subCategory: '(гаряча закуска)', 
        unit: ' г', 
        amount: 600, 
        price: 320, 
        image: "" 
    },

    { name: "3 персиком та сиром брі", 
        category: 'Кіш лорен',
        subCategory: '(гаряча закуска)', 
        unit: ' г', 
        amount: 650, 
        price: 380, 
        image: "" 
    },

    { name: "З шпинатом горбушею і кедровими горіхами", 
        category: 'Кіш лорен',
        subCategory: '(гаряча закуска)', 
        unit: ' г', 
        amount: 550, 
        price: 400, 
        image: "" 
    },
   
];

export default quicheLorraine;